// extracted by mini-css-extract-plugin
module.exports = {"text":"VrmWithCopy_text__P7J4o","vrm":"VrmWithCopy_vrm__oWK5X","yellow":"VrmWithCopy_yellow__PKtl_","white":"VrmWithCopy_white__Qiine","icon":"VrmWithCopy_icon__8MOe1"};